import { DownloadWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Download')
export class DownloadNodeSchemaProvider extends SchemaProvider<DownloadWorkflowNode> {}
